<template>
  <v-card
    v-if="item"
    class="white vetalfa-view"
    :max-width="_getMaxWidth()"
    flat
  >
    <div class="vetalfa-global-header" ref="screenHeader">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        hasHeaderOptions
        :title="topic ? topic.name : ''"
        :breadcrumb="!!item ? item.name : null"
      ></vetalfa-small-header>
      <v-row no-gutters justify="center">
        <vetalfa-drugs-header
          :isDrugsMode="true"
          :name="item.name"
          :references="item.references"
          :description="getDescription()"
          v-on:resize="setupScreenSizes()"
          class="vetalfa-max-width my-4 px-2"
        ></vetalfa-drugs-header>
      </v-row>
    </div>
    <div ref="screenContent">
      <vetalfa-internal-references
        :internalReferences="internalReferences"
      ></vetalfa-internal-references>
      <vetalfa-general-tab
        v-if="!item.tree && !!hasMounted"
        :sections="itemSections"
        :references="item.references"
        :topicName="topic ? topic.name : null"
        :itemName="item.name"
        :itemId="item.id"
        topics
        class="ma-0 pa-0"
      ></vetalfa-general-tab>
      <div v-else-if="!!hasMounted">
        <v-timeline
          id="vetalfa-algorithms-timeline"
          class="ma-0 pa-0"
          align-top
          dense
        >
          <algorithm-node
            v-for="node in nodes"
            :key="`algorithm-node-${node.level}`"
            :level="node.level"
            :headerHeightOffset="headerHeightOffset"
            class="ma-0 pa-0 py-2"
          ></algorithm-node>
        </v-timeline>
        <div class="navigation-blank-space"></div>
        <vetalfa-references-dialog></vetalfa-references-dialog>
      </div>
    </div>
    <vetalfa-ai-content-assistant
      v-if="item"
      :contextData="item"
      pageType="item"
      :pageName="item.name"
    />
  </v-card>
</template>

<style>
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 16px;
  top: var(--pseudo-timeline-top);
  right: initial;
  height: var(--pseudo-timeline-height);
}
.v-timeline--dense .v-timeline-item {
  padding-left: 8px !important;
}
.v-timeline--dense .v-timeline-item__body {
  max-width: 100%;
}
.v-timeline-item__divider {
  min-width: 16px;
}
.v-timeline-item__dot--small {
  height: 16px;
  width: 16px;
  margin-top: 2px;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import AlgorithmNode from "../components/AlgorithmNode.vue";
import ReferencesDialog from "@/components/ReferencesDialog.vue";
import InternalReferences from "@/components/InternalReferences.vue";
export default {
  components: {
    "algorithm-node": AlgorithmNode,
    "vetalfa-references-dialog": ReferencesDialog,
    "vetalfa-internal-references": InternalReferences,
  },
  name: "Item",
  data() {
    return {
      headerHeightOffset: null,
      hasMounted: false,
    };
  },
  computed: {
    ...mapGetters("algorithms", ["nodes"]),
    ...mapGetters("topics", ["item", "topic"]),
    internalReferences() {
      let arr = [];
      this.item.references.forEach((r) => {
        let hasRef = arr.find((i) => {
          return i.name === r.name;
        });
        if (!!r.type && r.type == 1 && !hasRef) {
          arr.push({
            ...r,
            category: r.category.replace("| Doses", "").trim(),
            path: r.path.split("/doses/")[0],
          });
        }
      });
      return this._shuffle(arr);
    },
    itemSections() {
      return !!this.item && !!this.item.sections ? this.item.sections : [];
    },
  },
  methods: {
    ...mapActions("topics", ["openTopicItem"]),
    ...mapActions("preferences", ["trackContentOpen"]),
    getDescription() {
      if (!!this.item.description) {
        return this.item.description;
      } else if (!!this.item.categories && this.item.categories.length > 0) {
        return this.item.categories.join(" | ");
      }
      return this.topic ? this.topic.name : "";
    },
    setupScreenSizes() {
      this._setupScreenSizes(this);
      this.headerHeightOffset = this.$refs.screenHeader.offsetHeight;
    },
  },
  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (!!this.item && this.item.id != id) {
          this.openTopicItem({ itemId: id }).then(() => {
            this.setupScreenSizes();
            this._scrollToZero(this);
            this.$nextTick(() => {
              setTimeout(
                function () {
                  const root = document.querySelector(":root");
                  let totalHeight = document.getElementById(
                    "vetalfa-general-tab"
                  ).offsetHeight;
                  root.style.setProperty(
                    "--pseudo-timeline-height",
                    `${totalHeight - 70}px`
                  );
                  root.style.setProperty("--pseudo-timeline-top", "10px");
                }.bind(this),
                100
              );
            });
          });
        }
      },
      deep: true,
      immediate: false,
    },
  },
  async mounted() {
    if (this.$route.params["id"]) {
      const loaded = await this.openTopicItem({ itemId: this.$route.params["id"] });
      if (loaded) this.trackContentOpen();
    }
    this.setupScreenSizes();
    this.hasMounted = true;
  },
};
</script>
